import imageField from 'molecules/Image/config';
import { videoField } from 'molecules/Video/config';

import type { Input } from '@builder.io/sdk';

export const featuredMediaConfigFields = [
  {
    name: 'enableCallout',
    type: 'boolean',
    defaultValue: true,
  },
  {
    name: 'callout',
    type: 'object',
    showIf: "options.get('enableCallout') === true",
    subFields: [
      {
        name: 'calloutPosition',
        type: 'string',
        enum: ['top', 'bottom', 'left', 'right'],
      },
      {
        name: 'isVideoPopup',
        type: 'boolean',
        defaultValue: false,
      },
      videoField('embed', "options.get('isVideoPopup') === true"),
      {
        name: 'videoPopupCopy',
        type: 'string',
        showIf: "options.get('isVideoPopup') === true",
      },
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'body',
        type: 'string',
      },
      {
        name: 'callToAction',
        type: 'object',
        showIf: "options.get('isVideoPopup') === false",
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'url',
            type: 'url',
          },
        ],
      },
    ],
  },
  {
    name: 'backgroundMediaType',
    type: 'string',
    enum: ['image', 'video'],
  },
  videoField('videoUrl', "options.get('backgroundMediaType') === 'video'"),
  imageField('backgroundImage', "options.get('backgroundMediaType') === 'image'"),
] as const satisfies DeepReadonly<Input[]>;

export const createFeaturedMedia = (showIf?: string): DeepReadonly<Input[]> => [
  {
    name: 'featuredMedia',
    type: 'object',
    subFields: featuredMediaConfigFields,
    showIf,
  },
];

export type FeaturedMediaProps = GenerateBuilder<typeof featuredMediaConfigFields>;
